import { makeAutoObservable } from 'mobx';

import labels from './uiLabels';

export interface IUiStore
{
  labels: typeof labels,
  isLoading: boolean,
  errorMessage: string,
  isError: boolean,
  loadAsync: () => Promise<void>,
}

export class UiStore implements IUiStore
{
  isLoading: boolean = false;
  private _errorMessage?: string = undefined;
  labels = labels;

  constructor()
  {
    makeAutoObservable(this);
  }

  async loadAsync()
  {
    await null;
  }

  get isError(): boolean
  {
    return this._errorMessage !== undefined;
  }
  get errorMessage(): string
  {
    return this._errorMessage || '';
  }

  protected async usingLoadingAsync(actionAsync: () => Promise<void>, errorHandler?: <T extends Error>(e: T) => void)
  {
    this.clearError();
    this.setIsLoading(true);
    try
    {
      await actionAsync();
    }
    catch (e)
    {
      const error = e as Error;
      if (errorHandler)
      {
        errorHandler(error);
      }
      else
      {
        this.setError(error);
      }
    }
    finally
    {
      this.setIsLoading(false);
    }
  }

  protected setIsLoading(isLoading: boolean): void
  {
    this.isLoading = isLoading;
  }
  protected setError(error: Error): void
  {
    console.log(error);
    this._errorMessage = error.message;
  }
  clearError(): void
  {
    this._errorMessage = undefined;
  }
}